export default __webpack_public_path__ + "static/media/figures-2.e96c540c.png";